import EhblManifestApiUrls from 'src/apiUrls/EhblManifestApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { 
  components,
  useTranslation
} from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useHistory } from 'react-router-dom'
import ConfirmDialog from '../../common/ConfirmDialog'
import ConfirmDialogMultipleAction from '../../common/ConfirmDialogMultipleAction'
import { useFormContext } from 'react-hook-form'
import EhblManifestKeys from 'src/constants/locale/key/EhblManifest'
import Namespace from 'src/constants/locale/Namespace'

const {
  button: { CngButton },
  form: { CngEditForm }
} = components

function ManifestEditPage(props) {
  const {
    id,
    manifestData,
    onChangeStep,
    onSetLoading,
    onSetManifestStatus,
    showNotification,
    step,
    handleUpdate,
    subLocationConfirmDialog,
    setSubLocationConfirmDialog
  } = props
  const { translate } = useTranslation(Namespace.EHBL_MANIFEST)

  const translatedTextsObject = makeTranslatedTextsObject()

  const onSuccessCallback = useRef(() => {})

  const [lookups, setLookups] = useState(null)
  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  function makeTranslatedTextsObject() {
      let updateSubLocationConfirmationMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_SUB_LOCATION_COMFIRMATION_MSG
      )
      let updateSubLocationConfirmationTitle = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_SUB_LOCATION_COMFIRMATION_TITLE
      )

      let updatePortAndSubLocationConfirmationMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_PORT_AND_SUB_LOCATION_COMFIRMATION_MSG
      )

      let updatePortAndSubLocationConfirmationTitle = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_PORT_AND_SUB_LOCATION_COMFIRMATION_TITLE
      )

      let okButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.OK_BUTTON
      )

       let noButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.NO_BUTTON
      )

      let discardButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.DISCARD_BUTTON
      )

      let skipButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.SKIP_BUTTON
      )

      let saveButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.SAVE_BUTTON
      )

      let saveAndContinueButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.SAVE_AND_CONTINUE_BUTTON
      )

      let discardConfirmationTitle = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.DISCARD_CONFIRMATION_TITLE
      )

      let discardConfirmationMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.DISCARD_CONFIRMATION_MSG
      )
      let continueEditButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.CONTINUE_EDIT_BUTTON
      )
      let yesDiscardButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.YES_DISCARD_BUTTON
      )

      let cancelButton = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.CANCEL_BUTTON
      )

    

      return {
        updateSubLocationConfirmationMsg,
        updateSubLocationConfirmationTitle,
        updatePortAndSubLocationConfirmationMsg,
        updatePortAndSubLocationConfirmationTitle,
        okButton,
        noButton,
        discardButton,
        skipButton,
        saveButton,
        saveAndContinueButton,
        discardConfirmationTitle,
        discardConfirmationMsg,
        continueEditButton,
        yesDiscardButton,
        cancelButton
      }
  }
  function getCountryStateLabel(country, state) {
    if (!lookups || !country || !state) return state

    // Check if country code exists in the lookup
    if (Object.keys(lookups.countries).includes(country)) {
      const result = lookups.countryStates[country].find(
        (countryState) => countryState.intlcode === state
      )

      return result ? result.descriptionEn : state
    } else {
      return state
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} >
        <CngEditForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              getLookupValue={getLookupValue}
              getCountryStateLabel={getCountryStateLabel}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            url: EhblManifestApiUrls.GET,
            onPreSuccess: (serverData) => {
              manifestData.current = serverData
              onSetManifestStatus(serverData.status)
            }
          }}
          update={{
            url: EhblManifestApiUrls.PUT,
            onPostSubmitSuccess: (e) => {
              manifestData.current = e
              onSetManifestStatus(e.status)
              onSuccessCallback.current()
            }
          }}
          id={id}
          renderButtonSection={(_, loading) => (
            <ManifestEditPageButtonSection
              manifestId={id}
              showNotification={showNotification}
              onSaveOnly={(data) => {
                if(data && (data.updateHouseBillSubLocationFlag == "true" || data.updateHouseBillPortFlag == "true")){
                  setSubLocationConfirmDialog({open : true, manifest : data, step : null})
                }else{
                  handleUpdate(data)
                }
                onSuccessCallback.current = () => {
                  onSetLoading(false)
                }
              }}
              onSaveAndContinue={(data) => {
                if(data && (data.updateHouseBillSubLocationFlag == "true" || data.updateHouseBillPortFlag == "true")){
                  setSubLocationConfirmDialog({open : true, manifest : data, step : step+1})
                }else{
                  handleUpdate(data,step + 1)
                }
                onSuccessCallback.current = () => {
                  onChangeStep(step + 1)
                  onSetLoading(false)
                }
              }}
              loading={loading}
              onSetLoading={onSetLoading}
              onSkip={() => onChangeStep(step + 1)}
              translatedTextsObject={translatedTextsObject}
            />
          )}
        />
      </Grid>
      <ConfirmDialogMultipleAction
        isConfirmDialogOpen={subLocationConfirmDialog.open}
        closeDialogAction={() => {
          subLocationConfirmDialog.manifest.updateHouseBillSubLocationFlag = "false"
          subLocationConfirmDialog.manifest.updateHouseBillPortFlag = "false"
          handleUpdate(subLocationConfirmDialog.manifest, subLocationConfirmDialog.step)
          setSubLocationConfirmDialog({open: false, manifest : {}, step : null})
        }}
        closeDialog={() => {
          setSubLocationConfirmDialog({open: false, manifest : {}, step : null})
        }}
        confirmDialog={() => handleUpdate(subLocationConfirmDialog.manifest, subLocationConfirmDialog.step)}
        content={subLocationConfirmDialog.manifest.updateHouseBillPortFlag == "true" ? translatedTextsObject.updatePortAndSubLocationConfirmationMsg : translatedTextsObject.updateSubLocationConfirmationMsg}
        okMsg={translatedTextsObject.okButton}
        cancelMsg={translatedTextsObject.cancelButton}
        title={subLocationConfirmDialog.manifest.updateHouseBillPortFlag == "true" ? translatedTextsObject.updatePortAndSubLocationConfirmationTitle : translatedTextsObject.updateSubLocationConfirmationTitle}
        
      />
    </Grid>
  )
}

export default ManifestEditPage

function ManifestEditPageButtonSection(props) {
  const {
    loading,
    onSaveOnly,
    onSaveAndContinue,
    onSetLoading,
    onSkip,
    translatedTextsObject
  } = props

  const [confirmDialog, setConfirmDialog] = useState(false)
  const { getValues, trigger, setValue } = useFormContext()
  const history = useHistory()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            {translatedTextsObject.discardButton}
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <Grid container spacing={2}>
            <Grid item xs='auto'>
              <CngButton
                color='secondary'
                disabled={loading}
                onClick={onSkip}
                size='medium'
              >
                {translatedTextsObject.skipButton}
              </CngButton>
            </Grid>
            <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                onClick={() => {
                   trigger().then(
                    (result)=>{
                      if(result){
                         onSaveOnly(FormProperties.toServerDataFormat(getValues()))
                      }
                    })
                }}
                //type='submit'
                size='medium'
                shouldShowProgress={loading}
              >
                 {translatedTextsObject.saveButton}
              </CngButton>
            </Grid>
            <Grid item xs='auto'>
              <CngButton
                color='primary'
                disabled={loading}
                onClick={()=> {
                  trigger().then(
                    (result)=>{
                      if(result){
                        onSaveAndContinue(FormProperties.toServerDataFormat(getValues()))
                      }
                    }
                  )
                }}
                //type='submit'
                size='medium'
                shouldShowProgress={loading}
              >
                {translatedTextsObject.saveAndContinueButton}
              </CngButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.EHBL_MANIFEST_LIST_VIEW)}
        content={translatedTextsObject.discardConfirmationMsg}
        okMsg={translatedTextsObject.yesDiscardButton}
        cancelMsg={translatedTextsObject.continueEditButton}
        title={translatedTextsObject.discardConfirmationTitle}
      />
    </>
  )
}
